var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{ref:"collapse",staticClass:"collapsible collection"},[_c('li',{staticClass:"collection-heading"},[_c('span',{staticClass:"collection-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }